import { render, staticRenderFns } from "./FromChangePassword.vue?vue&type=template&id=d72fbe0c"
import script from "./FromChangePassword.vue?vue&type=script&lang=js"
export * from "./FromChangePassword.vue?vue&type=script&lang=js"
import style0 from "./FromChangePassword.vue?vue&type=style&index=0&id=d72fbe0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports